// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__TLpX9","shrinkwrap":"styles_shrinkwrap__rNjzN","clamped":"styles_clamped__eG27o"};